<template>
    <page :busy="busy" :tabs="tabs" class="work-orders" :compact-mobile-view="true">
        <router-view></router-view>
    </page>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Page from '../generic/page/page.vue';
    import { removeScrollMixin } from '../../mixins/remove-scroll-mixin';

    const TAB = {
        workOrders: 'Work Orders',
        vendors: 'Vendors',
        expenseAccounts: 'Expense Accounts',
        jobTypes: 'Job Types',
    };

    export default {
        name: 'WorkOrders',
        mixins: [removeScrollMixin],
        components: {
            Page,
        },
        data() {
            return {
                basePath: '/app/work-orders',
                tabsToRender: [
                    {
                        title: TAB.workOrders,
                        route: '/app/work-orders/list/',
                        active: false,
                        disabled: false,
                    },
                    {
                        title: TAB.vendors,
                        route: '/app/work-orders/vendor-manager/grid/',
                        active: false,
                        disabled: false,
                    },
                    {
                        title: TAB.expenseAccounts,
                        route: `/app/work-orders/expense-accounts/`,
                        active: false,
                        disabled: false,
                    },
                    {
                        title: TAB.jobTypes,
                        route: `/app/work-orders/job-types/`,
                        active: false,
                        disabled: false,
                    },
                ],
                tabs: [],
                busy: false,
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            ...mapGetters('workOrders', ['metadata']),
        },
        methods: {
            ...mapActions('workOrders', ['fetchMetadata']),
            setActiveTab(path = '') {
                this.tabs = this.tabsToRender.filter(tab => !tab.disabled);
                this.tabs.forEach(tab => this.selectTab(path, tab));
            },
            selectTab(path, tab) {
                if (path.indexOf(`${this.basePath}/list`) !== -1) {
                    tab.active = tab.title === TAB.workOrders;
                } else if (
                    path.indexOf(`${this.basePath}/vendor-manager/create`) !==
                        -1 ||
                    path.indexOf(`${this.basePath}/vendor-manager/grid`) !==
                        -1 ||
                    path.indexOf(`/edit`) !== -1
                ) {
                    tab.active = tab.title === TAB.vendors;
                } else if (
                    path.indexOf(`${this.basePath}/expense-accounts`) !== -1
                ) {
                    tab.active = tab.title === TAB.expenseAccounts;
                } else if (path.indexOf(`${this.basePath}/job-types`) !== -1) {
                    tab.active = tab.title === TAB.jobTypes;
                } else {
                    tab.active = false;
                }
            },
            async loadMetadata() {
                try {
                    this.busy = true;
                    await this.fetchMetadata();
                } catch (err) {
                    this.errorToast({text: `Could not load metadata.`})
                } finally {
                    this.busy = false;
                }
            },
        },
        beforeMount() {
            (async () => {
                this.loadMetadata();
            })();
        },
        watch: {
            metadata: {
                immediate: true,
                handler(md) {
                    const disabledTabs = [TAB.expenseAccounts, TAB.jobTypes];
                    const hasConfigAccess =
                        this.metadata.permissions &&
                        this.metadata.permissions.has_config_access;

                    this.tabsToRender.forEach(
                        tab =>
                            (tab.disabled =
                                !hasConfigAccess &&
                                disabledTabs.includes(tab.title))
                    );
                    this.setActiveTab(this.$route.path);
                },
            },
            $route(to, from) {
                this.setActiveTab(to.path);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .work-orders {
        display: flex;
        flex-direction: column;
    }
</style>
